/** Server's endpoints */
export const ENDPOINTS = {
    TEMPLATES: '/v1/creator/templates',
    EDITOR: '/v1/creator/editor',
    DOCUMENT: '/v1/creator/document',
    CHAT: '/v1/creator/chat',
    SEND_CHAT: '/send-chat',
    SEARCH_ONLINE: '/search-online-chat',
    GUEST_SEARCH_ONLINE: '/guest-search-online-chat',
    CREATE_PROMPT: '/create-prompt',
    DELETE_PROMPT: '/delete-prompt',
    UPDATE_PROMPT: '/update-prompt',
    GET_PROMPTS: '/get-prompts',
    IMPROVE_PROMPT: '/improve-prompt',
    CONVERT_VOICE_TO_TEXT: '/convert-voice-to-text',
    DESIGNER: '/v1/creator/designer',
    REMOVE_BACKGROUND: '/remove-background',
    CHANGE_BACKGROUND: '/change-background',
    UPLOAD_REF_IMAGE: '/upload-reference-image',
    BILLING: '/v1/billing',
    CREATE_CHECKOUT_SESSION: '/create-checkout-session',
    CREATE_PORTAL_SESSION: '/create-portal-session',
    UPDATE_PLAN: '/update-plan',
    GET_DOCUMENT: '/get-document',
    USAGE: '/v1/creator/usage',
    LOGGER: '/v1/logger',
    RECORD_METRIC: '/record-metric',
    INCREMENT_METRIC: '/increment-metric',
    GET_DOCUMENTS: '/get-documents',
    CREATE_DOCUMENT: '/create-document',
    UPDATE_DOCUMENT: '/update-document',
    DELETE_DOCUMENTS: '/delete-documents',
    GENERATE_CONTENT: '/generate-content',
    LOG: '/log',
    UPDATE_USAGE: '/update-usage',
    GET_USAGE: '/get-usage',
    ADD_MEMBER: '/add-member',
    REMOVE_MEMBER: '/delete-member',
    GET_BRAND_VOICES: '/get-brand-voices',
    CREATE_BRAND_VOICE: '/create-brand-voice',
    UPDATE_BRAND_VOICE: '/update-brand-voice',
    DELETE_BRAND_VOICES: '/delete-brand-voices',
    DETECT_BRAND_VOICE: '/detect-brand-voice',
    USER: '/v1/creator/user',
    GET_USER: '/get-user',
    INFOBASE: '/infobase',
    GET_INFOBASE: '/get-infobase',
    UPLOAD_FILE: '/upload-file',
    DELETE_FILES: '/files',
    WORKFLOW: '/v1/creator/workflow',
    CREATE_WORKFLOW: '/create-workflow',
    GET_WORKFLOWS: '/get-workflows',
    UPDATE_WORKFLOW: '/update-workflow',
    DELETE_WORKFLOWS: '/delete-workflows',
    CREATE_WORKFLOW_ACTION: '/create-workflow-action',
    GET_WORKFLOW_ACTIONS: '/get-workflow-actions',
    UPDATE_WORKFLOW_ACTION: '/update-workflow-action',
    DELETE_WORKFLOW_ACTIONS: '/delete-workflow-actions',
};
